import type { User } from '$lib/shared/lib/types';

export async function fetchUser(
	fetch: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>
): Promise<User | null> {
	const res = await fetch('/api/auth/validate', {
		method: 'GET',
		credentials: 'include'
	});

	if (res.status !== 200) {
		return null;
	}

	return await res.json().then((data) => {
		return data.user;
	});
}

export async function fetchLogout(
	fetch: (input: RequestInfo | URL, init?: RequestInit) => Promise<Response>
) {
	return fetch('/api/auth/logout', {
		method: 'POST',
		credentials: 'include'
	});
}
